import React, { useEffect, useState } from "react";
import { Form, Input, Button, Row, Col, Select, FormInstance, Flex, Radio } from "antd";
import { Device } from "../../../types/device";
import GenericModal from "../../modal";
import { useGetAllDeviceIsNotUserPermissionQuery } from "../../../services/device";

interface AddDeviceFormProps {
    // getValueToAddDevice: (value: { deviceId: string; userPermissions: string }) => void;
    form: FormInstance<any>,
    userId: string
}
const AddDeviceForm: React.FC<AddDeviceFormProps> = ({ form, userId }) => {
  const { data: devices, error, isLoading } = useGetAllDeviceIsNotUserPermissionQuery(userId, {
    skip: !userId,
  });


  const onSearchDeviceId = (value: string) => {
  };


  const allDevice = devices?.map((device:Device) => {
    return {
      value: device._id,
      label: `${device.hardware_id} - ${device.device_name}`,
    };
  }
  );

  return (
    <Form form={form} initialValues={{ user_permissions: "Owner" }}  labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
      <div style={{ marginTop: "20px" }}></div>
      <Form.Item name="hardware_id" 
      label="Thiết bị"
      rules={[
        {
          required: true,
          message: "Vui lòng chọn thiết bị!",
        },
      ]}
      >
        <Select
          showSearch
          placeholder="Chọn thiết bị"
          optionFilterProp="label"
          onSearch={onSearchDeviceId}
          options={allDevice}
        />
      </Form.Item>
      <Form.Item label="Quyền người dùng" name="user_permissions" >
        <Flex vertical gap="middle">
          <Radio.Group block options={[
            {
              value: "Owner",
              label: "Owner",
            },
            {
              value: "Sharer",
              label: "Sharer",
            },
            {
              value: "Viewer",
              label: "Viewer",
            },
          ]} defaultValue="Owner" />
     
        </Flex>
      </Form.Item>

      <div style={{ marginBottom: "40px" }}></div>
    </Form>
  );
};

export default AddDeviceForm;
